var icon = require('vue-svgicon')
icon.register({
  'ks-icon-expand-all': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M39.52 77.21L64 101.69l24.48-24.48L96 84.79l-32 32-32-32zM29 69v-9.86h69V69zM88.48 50.79L64 26.31 39.52 50.79 32 43.21l32-32 32 32z"/>'
  }
})
